import React from "react";
import ModuleShowcasePage from "../../marketing/ModuleShowcasePage";

const AsapPartners = () => <ModuleShowcasePage moduleKey="partners" />;

export default AsapPartners;
